import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthState } from './auth.reducer';

const selectFeature = createFeatureSelector<IAuthState>('authWeb');

export const getFederatedLoginDataActionState = createSelector(
  selectFeature,
  state => state.federatedLoginDataActionState
);
